import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-600">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <span className="text-foreground-400 mx-1" aria-hidden="true">
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </span>
              )}
              {!isLast && item.href ? (
                <Link
                  to={item.href}
                  className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? 'text-foreground-900 font-medium whitespace-nowrap' : 'whitespace-nowrap'}>
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}